// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"23":"health-service","87":"tongue-diagnosis","150":"pulse-diagnosis","652":"health-assessment","738":"psychological-age","962":"home"}[chunkId] || chunkId) + "." + {"23":"4c968b9d","87":"8714600a","150":"4a147b3f","581":"fbe3b455","652":"2f5938b0","738":"117e1a99","962":"a83caaab"}[chunkId] + ".js";
};